import styled from 'styled-components';

const Label = styled.label`
  color: rgba(0, 0, 0, 1);
`;

export default Label;
